import { render } from "./Ranking.vue?vue&type=template&id=6bf0d9b0&scoped=true&ts=true&lang=pug"
import script from "./Ranking.vue?vue&type=script&lang=ts"
export * from "./Ranking.vue?vue&type=script&lang=ts"

import "./Ranking.vue?vue&type=style&index=0&id=6bf0d9b0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf0d9b0"]])

export default __exports__